var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfTreatmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#9FDCD2",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3051 14.2247L17.347 9.92811C17.1189 9.73247 16.8282 9.625 16.5277 9.625C16.2271 9.625 15.9365 9.73247 15.7083 9.92811L10.7502 14.2247C10.4746 14.4603 10.3149 14.8041 10.3125 15.1667V20.8567C10.313 21.1885 10.445 21.5066 10.6797 21.7412C10.9143 21.976 11.2325 22.108 11.5643 22.1085H21.4912C21.823 22.108 22.1411 21.976 22.3757 21.7412C22.6105 21.5066 22.7425 21.1885 22.743 20.8567V15.1667C22.7405 14.8041 22.5809 14.4603 22.3053 14.2247H22.3051ZM19.0662 19.3686H13.9889C13.7955 19.3686 13.6388 19.2117 13.6388 19.0184C13.6388 18.825 13.7955 18.6683 13.9889 18.6683H19.0662C19.2596 18.6683 19.4163 18.825 19.4163 19.0184C19.4163 19.2118 19.2596 19.3686 19.0662 19.3686Z",
    fill: "#00A185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfTreatmentIcon);
export default __webpack_public_path__ + "static/media/selfTreatmentIcon.1b760d62862cabb9429ee3b6194d0658.svg";
export { ForwardRef as ReactComponent };